import { useEffect, useState } from "react";

export function useMediaQuery(query: string) {
	const getMatch = () =>
			typeof window !== "undefined" ? window.matchMedia(query).matches : false;

	const [matches, setMatches] = useState(getMatch);

	useEffect(() => {
		const mql = window.matchMedia(query);
		const onChange = () => setMatches(mql.matches);

		onChange();
		mql.addEventListener?.("change", onChange);
		return () => mql.removeEventListener?.("change", onChange);
	}, [query]);

	return matches;
}